var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',[_c('v-container',{attrs:{"fluid":""}},[(_vm.$route.name === 'threadAdminDetail')?_c('admin-conversation-detail'):_c('admin-conversation-list')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }